import { AssetArchiveModelInfo } from "../../types/ArchiveSearchModel";
import { getAzureCall } from "../httpService";

export const getArchiveSearchData = async (params: AssetArchiveModelInfo) => {
    try {
        let url = process.env.REACT_APP_ARCHIVESEARCH_URL;

        // Dynamically set row bounds
        const queryParams: Record<string, string> = {
            firstRow: (params.StartRow ?? 0).toString(),
            lastRow: ((params.EndRow ?? 25) - 1).toString(),
        };

        if (params.SearchTerm && params.SearchTerm.trim() !== "") {
            queryParams.text = params.SearchTerm.trim();
        }

        // Append query string to the URL
        const queryString = new URLSearchParams(queryParams).toString();
        url = `${url}?${queryString}`;

        const response = await getAzureCall(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching archive search data", error);
        throw error;
    }
};
